"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Rewards API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateVoucher201ResponseToJSON = exports.CreateVoucher201ResponseFromJSONTyped = exports.CreateVoucher201ResponseFromJSON = exports.instanceOfCreateVoucher201Response = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the CreateVoucher201Response interface.
 */
function instanceOfCreateVoucher201Response(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfCreateVoucher201Response = instanceOfCreateVoucher201Response;
function CreateVoucher201ResponseFromJSON(json) {
    return CreateVoucher201ResponseFromJSONTyped(json, false);
}
exports.CreateVoucher201ResponseFromJSON = CreateVoucher201ResponseFromJSON;
function CreateVoucher201ResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'data': !(0, runtime_1.exists)(json, 'data') ? undefined : json['data'],
    };
}
exports.CreateVoucher201ResponseFromJSONTyped = CreateVoucher201ResponseFromJSONTyped;
function CreateVoucher201ResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'data': value.data,
    };
}
exports.CreateVoucher201ResponseToJSON = CreateVoucher201ResponseToJSON;
